module.exports = __webpack_public_path__ + "img/douyin.98b3d70f.webp";